<script setup lang="ts">
import AnalysisPost from '@/content-types/analysis-post/AnalysisPost.vue';
import useAnalysisPost from '@/content-types/analysis-post/useAnalysisPost';
import { useAnalysisPostRoute } from '@/content-types/analysis-post/useAnalysisPostRoute';
import { useSeoMeta } from '#app';

const { getPostSlugFromRoute } = useAnalysisPostRoute();
const { fetchPost, getPostMeta } = useAnalysisPost();

const post = await fetchPost(getPostSlugFromRoute());
const meta = getPostMeta(post);
const { title, standfirst } = post;

useSeoMeta({
  title,
  ogTitle: title,
  description: standfirst,
  ogDescription: standfirst,
  ogImage: meta.image,
});
</script>

<template>
  <AnalysisPost :post-data="post" />
</template>
